import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { INVESTMENT_API } from "./apiRoutes";

const mutateUpdateStrategicInvestment = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${INVESTMENT_API}/${id}`, data);
};

const useUpdateStrategicInvestmentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateStrategicInvestment,
    ...queryParams,
  });

export default useUpdateStrategicInvestmentMutation;
